export function getClientShortSHA(): string {
  if (typeof document === 'undefined') return ''
  const content = document
    .querySelector('meta[name="app-version"]')
    ?.getAttribute('content')
  return content ?? ''
}
